import React, { useState } from 'react';
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDateTimePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { primary_color } from "../../style_constants";

export const DateTimerPickers = (props) => {
  const {
    index,
    value,
    handleChange,
    helperText,
    placeholder,
    futureDateHide,
    isDynamicField,
  } = props.componentObject;

  const [changed, setChanged] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {
      "& > *": {
        margin: theme.spacing(1),
        display: "flex",
      },
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
  }));

  // const theme = createMuiTheme({
  //   overrides: {
  //     MuiPickersToolbar: {
  //       toolbar: {
  //         backgroundColor: primary_color
  //       }
  //     },
  //     MuiPickersDay: {
  //       daySelected: {
  //         backgroundColor: primary_color
  //       }
  //     },
  //     MuiButton: {
  //       textPrimary: {
  //         color: primary_color
  //       }
  //     },
  //     MuiFormControl: {
  //       marginNormal: {
  //         marginTop: "0px",
  //         marginBottom: "0px",
  //         // marginLeft: "1px"
  //       }
  //     },
  //     MuiOutlinedInput: {
  //       input: {
  //         color: changed || value ? 'black' : '#a5a5a5',
  //         "&::placeholder": {
  //           color: '#808080 !important',
  //           opacity: 1
  //         }
  //       }
  //     }
  //   },
  // });

  const classes = useStyles();

  return (
    <React.Fragment>
      {/* <ThemeProvider theme={theme}> */}
      <Grid container className={classes.gridRoot}>
        <Grid item xs={12} md={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDateTimePicker
              fullWidth
              placeholder={placeholder ? placeholder : "MM/DD/YYYY HH:MM"}
              inputVariant="outlined"
              size="small"
              margin="normal"
              format="dd/MM/yyyy HH:mm"
              value={value}
              error={helperText ? true : false}
              helperText={helperText}
              maxDate={futureDateHide ? new Date() : undefined}
              disablePast={false}
              onChange={(val) => { handleChange(val, index, props.componentObject.selectValue?.index, isDynamicField); setChanged(true); }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>

        </Grid>
      </Grid>
      {/* </ThemeProvider> */}
    </React.Fragment>
  );
}

export default function DateTimerPicker(props) {
  const { label } = props.componentObject;
  return (
    <Grid container >
      {
        label &&
        <Grid item xs={12} md={4}>
          {label}
        </Grid>
      }
      <Grid item xs={12} md={label ? 7 : 12}>
        <DateTimerPickers componentObject={props.componentObject} />
      </Grid>
    </Grid>
  );
}
